export default __webpack_public_path__ + "static/media/p72.b9740b33.jpg";